import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserInfoResolver } from '@shared/resolvers/user-info.resolver';
import { loginRedirectGuard } from '@shared/guards/login-redirect.guard';

const routes: Routes = [
    {
        path: '',
        canActivate: [loginRedirectGuard],
        resolve: {
            userCustomerInfos: UserInfoResolver,
        },
        loadChildren: () => import('app/app.module').then((m) => m.AppModule), // Lazy load account module
        data: { preload: true },
    },
    {
        path: 'account',
        loadChildren: () => import('account/account.module').then((m) => m.AccountModule), // Lazy load account module
        data: { preload: true },
    },
    {
        path: 'app',
        resolve: {
            userCustomerInfos: UserInfoResolver,
        },
        loadChildren: () => import('app/app.module').then((m) => m.AppModule), // Lazy load account module
        data: { preload: true },
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
    exports: [RouterModule],
    providers: [],
})
export class RootRoutingModule {}
